import Vue from "vue";
import bus from "@/bus";

const functions = Vue.mixin({
  data() {
    return {
      validCheck: false
    };
  },
  props: {
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    subscribe(element) {
      // Lo suscribo al FormValidator, si existe
      // Busco el form que lo envuelve (si existe)
      let elem = this.$parent;
      while (elem && !elem.subscribe) {
        elem = elem.$parent;
      }

      if (elem) {
        elem.subscribe(element);
      }
    },
    checkValid() {
      this.validCheck = true;
      return this.isValid();
    },
    isValid() {
      if (this.required) {
        return !!(this.value && this.value.trim() !== "");
      }
      return true;
    },
    reValidateForm() {
      bus.$emit("formValidate");
    }
  },
  computed: {
    error() {
      if (this.validCheck && !this.isValid()) {
        return "Tenés que ingresar este dato";
      }
      return null;
    }
  },
  mounted() {
    // Lo suscribo para que lo trate el form
    this.subscribe(this);
  },
  updated() {
    this.reValidateForm();
  }
});

export default functions;
